import { PageSubtitle } from "@components/common/page-subtitle";
import { RegisterableServer } from "@custom-types/server-types";
import { Box } from "@mui-wrapper";
import { InvitedSubtitle } from "@pages/invited/invited-subtitle";
import { TrialEmail } from "@pages/trial/trial-email";

interface Props {
  /** Callback to set the validated email and its registerable server entity */
  setEmailAndServer: (email: string, server: RegisterableServer) => void;
}

/**
 * Renders the email step of the invited user registration flow.
 * It is only shown when the invitation link does not carry the email address,
 * so the user can enter the email address the invitation was sent to.
 */
export function InvitedStepEmail({ setEmailAndServer }: Props): JSX.Element {
  return (
    <Box
      data-testid="invited-step-email"
      sx={{
        width: "100%",
      }}
    >
      <InvitedSubtitle />
      <PageSubtitle
        sx={{
          marginBottom: "16px",
        }}
      >
        Enter the email address your invitation was sent to.
      </PageSubtitle>
      <TrialEmail setEmailAndServer={setEmailAndServer} />
    </Box>
  );
}
